import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { JoinGroupPage } from '@/features/groups'

const joinGroupSearchSchema = z.object({
  code: z.string().optional()
})

export const Route = createFileRoute('/_authenticated/_main/grupos/entrar')({
  validateSearch: joinGroupSearchSchema,
  component: JoinGroupPage
})
